module.exports = __webpack_public_path__ + "img/download-cloud.1ee98739.svg";